"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledGridTotalRowContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const base_1 = require("../../../../../design/themes/base");
exports.StyledGridTotalRowContainer = styled_components_1.default.div `
    display: flex;
    flex-direction: row;
    height: 32px;
    background-color: ${base_1.baseTheme.colorHighlightNotification.var()};
    border-bottom: 1px solid ${base_1.baseTheme.colorBorderGrid.var()};
`;
//# sourceMappingURL=GridTotalRowContainer.styles.js.map